
import {Injectable} from "@angular/core";
import {RecordingBadge} from "../services/usermodel/usermodel.objects";

@Injectable()
export class SelectionReportSummaryStatus  {

    constructor() {}

    public determineSummaryStatus(hasQuizStar: boolean, recordingBadge: RecordingBadge): ISelectionReportRecordingStatus {
        if (hasQuizStar && recordingBadge === RecordingBadge.GOLDEN) {
            return new ExcellentRecordingStatus();
        } else if (hasQuizStar && recordingBadge === RecordingBadge.SILVER) {
            return new GoodRecordingStatus();
        } else {
            return new CompleteRecordingStatus();
        }
    }

}

export interface ISelectionReportRecordingStatus {
    designation:string;
    localizationKey: string;
    img: string;

}

export class ExcellentRecordingStatus implements ISelectionReportRecordingStatus {
    designation:string = "gold";
    localizationKey: string = "RA_RPT_SEL_01";
    img:string = "img-recording-status-excellent";

}

export class GoodRecordingStatus implements ISelectionReportRecordingStatus {
    designation:string = "silver";
    localizationKey: string = "RA_RPT_SEL_02";
    img:string = "img-recording-status-good";

}

export class CompleteRecordingStatus implements ISelectionReportRecordingStatus {

    designation:string = "checkmark";
    localizationKey: string = "RA_RPT_SEL_03";
    img:string = "img-recording-status-complete";
}


